import { ReactElement } from 'react';
import { PaginationLink } from '../../PaginationLink';

interface IProps {
  page: number;
  onClick: (page: number) => Promise<void>;
}

export const S_PaginationPageButton = ({ page, onClick }: IProps): ReactElement => {
  const handleClick = async (): Promise<void> => {
    await onClick(page);
  };

  return <PaginationLink onClick={handleClick}>{page}</PaginationLink>;
};
